// extracted by mini-css-extract-plugin
export default {"flash_message":"Flash_flash_message__4J3Hz"};